export const ACCOUNT_ACTIVE = 'account-active';

export const ACCOUNT_RESTRICTED = 'account-restricted';
